import { createReducer, on } from '@ngrx/store';
import { multimapsResponse } from '@shared/interfaces/maps/multiMaps.interfaces';
import { loadCalculateRoutesSuccessByKey } from './calculate-routes.actions';

export interface CalculateRoutesState {
  cache: { [key: string]: multimapsResponse };
}

export const initialState: CalculateRoutesState = {
  cache: {},
};

export const calculateRoutesReducer = createReducer(
  initialState,
  on(loadCalculateRoutesSuccessByKey, (state, { key, response }) => ({
    ...state,
    cache: { ...state.cache, [key]: response },
  })),
);
